import Header from "@/components/Header";
import Footer from "@/components/Footer";
import DiscountProductList from "@/components/DiscountProductList";

const DiscountsPage = () => {
  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <Header />
      <main className="container mx-auto p-4 sm:p-6 md:p-8 flex-grow">
        <h1 className="text-4xl font-bold mb-6 text-primary">Aktuális Akciók</h1>
        <DiscountProductList />
      </main>

      <Footer />
    </div>
  );
};

export default DiscountsPage;